import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-690927c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode("Close")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalHeader = _resolveComponent("ModalHeader")!
  const _component_CloudMDTermsAndConditionsText = _resolveComponent("CloudMDTermsAndConditionsText")!
  const _component_TermsAndConditionsText = _resolveComponent("TermsAndConditionsText")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_PageWrapper = _resolveComponent("PageWrapper")!

  return (_openBlock(), _createBlock(_component_PageWrapper, { contentWidthFull: "" }, {
    "content-header": _withCtx(() => [
      _createVNode(_component_ModalHeader, { "header-text": "Terms of Use" })
    ]),
    "content-top": _withCtx(() => [
      (_ctx.isCloudMD)
        ? (_openBlock(), _createBlock(_component_CloudMDTermsAndConditionsText, {
            key: 0,
            inModalMode: true
          }))
        : (_openBlock(), _createBlock(_component_TermsAndConditionsText, {
            key: 1,
            class: "terms-modal-content",
            inModalMode: true
          }))
    ]),
    "content-bottom": _withCtx(() => [
      _createVNode(_component_BaseButton, { onClick: _ctx.dismissModal }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }))
}